var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4164C10.8179 17.4175 10.6397 17.3643 10.4879 17.2637C10.3362 17.163 10.2179 17.0195 10.1481 16.8513C10.0783 16.6832 10.0601 16.498 10.0959 16.3195C10.1317 16.141 10.2199 15.9772 10.3492 15.8489L15.2075 10.9998L10.3492 6.15061C10.199 5.97525 10.1205 5.74968 10.1294 5.51898C10.1383 5.28828 10.234 5.06943 10.3972 4.90618C10.5605 4.74293 10.7793 4.64729 11.01 4.63838C11.2407 4.62947 11.4663 4.70794 11.6417 4.85811L17.1417 10.3581C17.3124 10.5299 17.4082 10.7622 17.4082 11.0044C17.4082 11.2465 17.3124 11.4789 17.1417 11.6506L11.6417 17.1506C11.4709 17.32 11.2405 17.4154 11 17.4164Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.4162C5.31793 17.4172 5.13966 17.3641 4.98794 17.2634C4.83621 17.1628 4.7179 17.0192 4.64808 16.851C4.57826 16.6829 4.5601 16.4977 4.59591 16.3192C4.63173 16.1407 4.71989 15.9769 4.84917 15.8487L9.7075 10.9995L4.84917 6.15035C4.67656 5.97774 4.57958 5.74363 4.57958 5.49952C4.57958 5.25541 4.67656 5.0213 4.84917 4.84869C5.02178 4.67607 5.25589 4.5791 5.5 4.5791C5.74411 4.5791 5.97822 4.67607 6.15083 4.84869L11.6508 10.3487C11.8216 10.5204 11.9174 10.7528 11.9174 10.9949C11.9174 11.2371 11.8216 11.4694 11.6508 11.6412L6.15083 17.1412C6.06594 17.2278 5.9647 17.2967 5.85298 17.3439C5.74126 17.3911 5.62128 17.4157 5.5 17.4162Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2440328c0a90d17a420c9f4486d6706d.svg";
export { ForwardRef as ReactComponent };